export const FUNCTIONAL_FITNESS = [
  "CrossFit",
  "Circuit Training",
  "Indoor Bootcamp",
  "Outdoor Bootcamp",
  "Kettlebell Training",
  "TRX Training",
  "Battle Ropes",
  "Plyometrics",
  "Calisthenics",
  "Olympic Weightlifting",
  "Strongman",
  "Ninja Warrior Training",
  "Strength and Conditioning",
] as const;

export const STRENGTH = [
  "Weightlifting",
  "Powerlifting",
  "Bodybuilding",
] as const;

export const COMBAT_SPORTS = [
  "Boxing",
  "Kickboxing",
  "Muay Thai",
  "Brazilian Jiu-Jitsu",
  "Taekwondo",
  "Karate",
  "Combat Sports",
] as const;

export const GROUP_FITNESS = [
  "Zumba",
  "Spinning",
  "Barre",
  "Dance Classes",
  "Group Circuit Training",
  "Group Classes",
] as const;

export const FLEXIBILITY_AND_MOBILITY = [
  "Yoga",
  "Pilates",
  "Stretching",
  "Foam Rolling",
  "Tai Chi",
] as const;

export const MIND_BODY = [
  "Meditation",
  "Mindful Breathing",
  "Relaxation Techniques",
  "Qi Gong",
  "Pranayama",
  "Sauna",
] as const;

export const OUTDOOR_ACTIVITIES = [
  "Hiking",
  "Trail Running",
  "Outdoor Cycling",
  "Kayaking",
  "Rock Climbing",
  "Surfing",
  "Disc Golfing",
  "Stand-up Paddleboarding",
] as const;

export const SPORTS_SPECIFIC_TRAINING = [
  "Basketball Training",
  "Track & Field",
  "Football Training",
  "Soccer Training",
  "Golf",
  "Softball Training",
  "Baseball Training",
  "Hockey Training",
  "Speed School",
  "Sports Performance",
] as const;

export const CARDIO = [
  "Treadmill",
  "Elliptical",
  "Stationary Bike",
  "Rowing Machine",
  "Stair Climber",
  "Jump Rope",
  "Running",
  "Indoor Cycling",
  "Swimming",
  "HIIT",
] as const;

export const SPECIALTY_TRAINING = [
  "Rehabilitation Exercises",
  "Pre- and Post-Natal Fitness",
  "Senior Fitness",
  "Adaptive Fitness",
  "Tactical Training",
] as const;

export const PERSONAL_TRAINING = ["Personal Training"] as const;

export const HEALTH_CLUB = ["Health Club", "24/7 Access"] as const;

// Legacy support: "Other" category maintained for data migration purposes only.
// Prior to the introduction of gym subtypes, many gyms had the
// type "Other" or no type at all.
// Do not expose to new clients - use specific categories instead.
export const OTHER = ["Other"] as const;

export const ALL_GYM_SUBTYPES = [
  ...FUNCTIONAL_FITNESS,
  ...STRENGTH,
  ...COMBAT_SPORTS,
  ...GROUP_FITNESS,
  ...FLEXIBILITY_AND_MOBILITY,
  ...MIND_BODY,
  ...OUTDOOR_ACTIVITIES,
  ...SPORTS_SPECIFIC_TRAINING,
  ...SPECIALTY_TRAINING,
  ...CARDIO,
  ...PERSONAL_TRAINING,
  ...HEALTH_CLUB,
  ...OTHER,
] as const;

export type GymSubtype = (typeof ALL_GYM_SUBTYPES)[number];

export const GYM_TYPES = [
  "Functional Fitness",
  "Strength",
  "Combat Sports",
  "Group Fitness",
  "Flexibility and Mobility",
  "Mind Body",
  "Outdoor Activities",
  "Sports Specific Training",
  "Cardio",
  "Specialty Training",
  "Personal Training",
  "Health Club",
  "Other",
] as const;

export type GymType = (typeof GYM_TYPES)[number];
